<template>
    <div
        class="formfield formfield--select"
        :class="{'formfield--error': (error)}">
        <label
            class="formfield__label">
            <slot name="label">{{ label }}</slot>
            <span
                class="required"
                v-if="required">*</span>
        </label>


        <div class="formfield__input">
            <div
                class="customselect"
                :class="placeholderClass">
                <input
                    autocomplete="off"
                    ref="currentValue"
                    @input="updateValue()"
                    @change="updateValue()"
                    @click="toggle"
                    :value="(svalue && svalue.label) || typedValue"
                    :placeholder="placeholder"/>

                <ul v-if="open">
                    <li v-for="product in filteredOptions"
                        :value="product.id"
                        :key="product.id"
                        :disabled="product.disabled"
                        @click="select(product)" v-html="product.label">
                    </li>
                </ul>

            </div>
            <div
                class="formfield__error">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .customselect {
        padding-left: 0.5rem;
        padding-right: 0.5rem;

        ul {
            max-height: 15vh;
            overflow-y: scroll;

            li {
                margin-top: 0.5rem;
                margin-bottom: 0.5rem;
            }
        }
    }

    input {
        background-color: transparent ;
        background-image: none !important;
    }

    li:hover {
        background-color: rgba(0,0,0,0.2);
    }
</style>

<script>
export default {
    inheritAttrs: false,
    $_veeValidate: {
        value () {
            return this.$refs.currentValue.value;
        }
    },
    data() {
        return {
            svalue: undefined,
            open: false,
            typedValue: '',
        }
    },
    props: {
        placeholder: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        errors: {
            type: Object,
            default: null
        },
        required: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: '',
        },
        value: {
            default: null,
            type: Object|String,
        },
        options: {
            type: Array
        }
    },
    computed: {
        error() {
            if (this.errors) {
                return this.errors.first(this.name);
            }

            return null;
        },
        placeholderClass() {
            if(!this.value) {
                return 'customselect--placeholder';
            }

            return '';
        },

        filteredOptions() {
          return this.options.filter((item) => {
              const l = item.label.toLowerCase();
              return l.includes(this.typedValue.toLowerCase())
          })
        },
    },
    watch: {
        value(value) {
            if (value) {
                this.select(value)
            }
        }
    },
    methods: {
        removeError() {
            if (this.errors) {
                this.errors.remove(this.name);
            }
        },

        updateValue() {
            this.typedValue = this.$refs.currentValue.value;
            this.svalue = undefined;
        },
        toggle() {
            if (this.open) {
              this.select(null)
            } else {
                this.open = true
            }
        },
        select(item) {
            this.svalue = item;
            this.$emit('input', item);
            this.open = false;
        }
    },
};
</script>
